<template>
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.4977 16.9842C13.1909 16.9842 16.9954 13.1822 16.9954 8.49212C16.9954 3.80205 13.1909 0 8.4977 0C3.80455 0 0 3.80205 0 8.49212C0 13.1822 3.80455 16.9842 8.4977 16.9842Z"
      fill="#1CD17B" />
    <path
      d="M7.95088 12.3693C7.6933 12.6839 7.22426 12.7175 6.92449 12.4427L4.40688 10.1355C4.02847 9.78869 4.00286 9.20078 4.3497 8.82239C4.69649 8.44407 5.28429 8.41846 5.66266 8.76521L7.28337 10.2505L11.2232 5.43777C11.5483 5.04065 12.1338 4.98221 12.531 5.30724C12.9283 5.63236 12.9867 6.21801 12.6615 6.61524L7.95088 12.3693Z"
      fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Check',
};
</script>
